import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { _Api } from "../../api/_call";
import {
  LocationList,
  SupplierList,
  VoucherList,
} from "../../common/graphql/commonlayouts";
import './createpoReplenishOrder.scss';

import { SetdataTable, UnSetdataTable } from "../../api/setdatatable";
import TableColumnModal from "../../common/modules/tableColumn";
import ConfirmationModel from "../../common/modules/confirmationmodel";
import { Tablehead } from "../../common/modules/Tablehead";
import Advancedfiltermodel from "../../common/modules/advanced-filter-model";
import NotesModalLabel from "../../common/modules/NotesModalLabel";
import { calDuedate, formatDate } from "../../common/helpers/formatDate";
import Select from "react-select";
import { toFormatPrice, toUnformatPrice } from "../../common/helpers/function";
import { error, loading, Updateloading } from "../../common/helpers/toastify";
import { createPOReworktablehead } from "../../common/Tablehead";
import TransAndDeliverDate from "../../common/modules/TransAndDeliverDate";
import SocialModal from "../../common/modules/SocialModal/SocialModal";
import ProductModal from "../../common/modules/ProductModal";
import Stockidmodal from "../../common/modules/Stockidmodal";
const CreatePOReworkOrder = (props) => {
  const { t } = useTranslation();
  const base_url = process.env.REACT_APP_BASE_ASSETS_URL;
  const navigate = useNavigate();
  const { state } = useLocation();
  const productSearchBar = useRef(null);
  const listRef = useRef(null);
  const [ShowProductSearchBar, setShowProductSearchBar] = useState(false);
  const [inventorySearchResults, setInventorySearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchNoResults, setSearchNoResults] = useState(false);
  const [selectingProduct, setSelectingProduct] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [form_note, setForm_note] = useState(null);
  const [commanSelected_loc, setcommanSelected_loc] = useState(null);
  const [commanSelected_sup, setcommanSelected_sup] = useState(null);
  const [commanSelected_vouc, setcommanSelected_vouc] = useState(null);
  const [PO_OrdersList, setPO_OrdersList] = useState([]);
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [DeliveryDate, setDeliveryDate] = useState();
  const [newcolumndata, setnewcolumndata] = useState(createPOReworktablehead);
  const [selecteditem, setSelecteditem] = useState([]);
  const [SelectAllStatus, setSelectAllStatus] = useState();
  const [poExportFormat, setPoExportFormat] = useState("xlsx");
  const [limit, setLimit] = useState(100);
  const [filtername, setFiltername] = useState('');
  const [getoneproduct, setOneproduct] = useState();
  const [oneproductindex, setoneproductindex] = useState();
  // const [pos, setPos] = useState()
  const getdeliverydate = async () => {
    setDeliveryDate(await calDuedate(new Date()));
  }
  useEffect(() => {
    getdeliverydate();
  }, []);

  const handleClickOutside = (event) => {
    if (productSearchBar.current && !productSearchBar.current.contains(event.target)) {
      setShowProductSearchBar(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const listElement = listRef.current;
    if (listElement && listElement.children[highlightedIndex]) {
      listElement.children[highlightedIndex].scrollIntoView({
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  const selectOptions = [
    { label: 100, value: 100 },
    { label: 200, value: 200 },
    { label: 300, value: 300 }
  ]

  let mapChange_handle = (i, value, type) => {
    let data = [...PO_OrdersList];
    data[i][type] = value;
    setPO_OrdersList(data);
  };

  const getMaxQty = (row) => {
    const max = parseInt(row?.po_QTY ?? row?.product_details?.po_QTY ?? 1, 10);
    return Number.isFinite(max) && max > 0 ? max : 1;
  };

  const handleQtyChange = (index, rawValue) => {
    const data = [...PO_OrdersList];
    const maxQty = getMaxQty(data[index]);

    if (rawValue === "") {
      data[index].Qty = "";
      setPO_OrdersList(data);
      return;
    }

    const qty = parseInt(rawValue, 10);
    if (!Number.isFinite(qty) || qty < 1) {
      return;
    }

    if (qty > maxQty) {
      error(t("Qty cannot be more than available stock") + ` (${maxQty})`);
      data[index].Qty = maxQty;
      setPO_OrdersList(data);
      return;
    }

    data[index].Qty = qty;
    setPO_OrdersList(data);
  };
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_po_createpo_rework",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const po_create_submit = async () => {
    try {
      if (!commanSelected_vouc) {
        error(t("Please select voucher"));
        return;
      }
      if (!commanSelected_loc) {
        error(t("Please select location"));
        return;
      }
      if (!TransactionDate) {
        error(t("Please select Transaction Date"));
        return;
      }
      if (!DeliveryDate) {
        error(t("Please select Delivery Date"));
        return;
      }
      var checkedValue = document.querySelectorAll(".PO_OrdersList:checked");
      var product_data = [];
      for (let c = 0; c < checkedValue.length; c++) {
        const i = checkedValue[c].getAttribute("data-key");
        const rowQty = parseInt(PO_OrdersList[i]["Qty"], 10);
        const maxQty = getMaxQty(PO_OrdersList[i]);
        if (!Number.isFinite(rowQty) || rowQty < 1) {
          error(t("Please enter a valid quantity"));
          return;
        }
        if (rowQty > maxQty) {
          error(t("Qty cannot be more than available stock") + ` (${maxQty})`);
          return;
        }
      }
      checkedValue.forEach(function (result) {
        var i = result.getAttribute("data-key");
        var product_details = PO_OrdersList[i]["product_details"];
        var order_type=PO_OrdersList[i]['pos']['order_type']
        product_data.push({
          poforrework: true,
          repair_connect_po_product_id:order_type==="repair_order"?product_details['repair_connect_po_product_id']:"",
          po_product_id: product_details["po_product_id"] || "",
          product_id: product_details["product_id"],
          stock_id: product_details["stock_id"] || PO_OrdersList[i]["stock_id"] || "",
          oldStock_id: product_details["stock_id"] || PO_OrdersList[i]["stock_id"] || "",
          customer_id:
            PO_OrdersList[i]["Customer_id"] ||
            PO_OrdersList[i]["customer_id"] ||
            PO_OrdersList[i]?.pos?.customer_id ||
            "",
          so_no: PO_OrdersList[i]["So_No"],
          po_QTY: parseInt(PO_OrdersList[i]["Qty"]),
          price: toFormatPrice(PO_OrdersList[i]["price"]),
          amount_total: toFormatPrice(PO_OrdersList[i]["price"] * parseInt(PO_OrdersList[i]["Qty"])),
          sales_order_id: PO_OrdersList[i]["id"],
          remark: "",
          remarkforrework: PO_OrdersList[i]["remarkforrework"] || "",
          Style: product_details["Style"],
          Metal: product_details["Metal"],
          Color: product_details["Color"],
          Size: product_details["Size"],
          Unit: product_details["Unit"],
          GrossWt: product_details["GrossWt"],
          NetWt: product_details["NetWt"],
          Stone: product_details["Stone"],
          StoneGroup: product_details["StoneGroup"],
          StoneVariant: product_details["StoneVariant"],
          StoneShape: product_details["StoneShape"],
          Pcs: product_details["Pcs"],
          WeightType: product_details["WeightType"],
          StoneCut: product_details["StoneCut"],
          StoneClarity: product_details["StoneClarity"],
          StoneColor: product_details["StoneColor"],
          stoneSize: product_details["stoneSize"],
          certificate: product_details["certificate"],
          Certificatetype: product_details["Certificatetype"],
          certificateNo: product_details["certificateNo"],
          Weight: product_details["Weight"],
          Stones: product_details["Stones"],
        });
      });
      if (!product_data.length) {
        error(t("No item Selected!!"));
        return;
      }
      const postdata = {
        voucher_id: commanSelected_vouc,
        location_id: commanSelected_loc,
        supplier_id: commanSelected_sup,
        delivery_date: DeliveryDate,
        transaction_date: TransactionDate,
        note: form_note,
        po_data: product_data,
        RefNo: '',
      };
      let GetloadingID = loading();
      try {
        let resPoOrders = await _Api(postdata, `api/v1/Inventory/po/createPO`);
        if (resPoOrders.code === 200) {
          Updateloading(t, GetloadingID, t("Added successfully!!"));
          const timer = setTimeout(() => {
            navigate("/app/inventory");
          }, 1000);
          return () => clearTimeout(timer);
        } else {
          Updateloading(
            t,
            GetloadingID,
            resPoOrders.errors || resPoOrders?.message || t("Something went wrong"),
            "error"
          );
        }
      } catch (err) {
        Updateloading(t, GetloadingID, t("Something went wrong"), "error");
      }
    } catch (err) { }
  };
  const posorders_idshave = useCallback(async () => {
    UnSetdataTable("tbl_pos_order_table");
    SetdataTable("tbl_pos_order_table", "6", newcolumndata);
  }, [newcolumndata]);

  const formatReworkApiError = (resp) => {
    if (resp?.errors) {
      if (typeof resp.errors === "string") return resp.errors;
      if (typeof resp.errors === "object") {
        return Object.values(resp.errors).flat().join(", ");
      }
    }
    return resp?.message || t("Something went wrong");
  };

  const getInventoryRecordId = (data) =>
    data?._id || data?.ID || "";

  const getReworkCostPrice = (data) =>
    data?.costprice ?? data?.costPrice ?? data?.CostPrice ?? 0;

  const isInventoryRecordInList = (rows, data) => {
    const recordId = getInventoryRecordId(data);
    if (!recordId) return false;
    return rows.some((row) => {
      const existingId =
        getInventoryRecordId(row) || getInventoryRecordId(row?.product_details);
      return existingId === recordId;
    });
  };

  const mapInventoryProductToReworkRow = (data) => ({
    _id: getInventoryRecordId(data),
    id: getInventoryRecordId(data) || data?.po_product_id || data?.product_id || `inv_${Date.now()}`,
    stock_id: data?.stock_id || "",
    createdAt: new Date(),
    Qty: data?.po_QTY ?? 1,
    po_QTY: data?.po_QTY ?? 1,
    price: getReworkCostPrice(data),
    remarkforrework: "",
    location_name: data?.location_name || "",
    customer_name: "",
    delivery_date: "",
    Customer_id: "",
    So_No: data?.po_no || "",
    po_product_id: data?.po_product_id,
    poforrework: data?.poforrework,
    product_details: {
      ...data,
      product_id: data?.product_id,
      po_product_id: data?.po_product_id,
      stock_id: data?.stock_id,
      main_image: data?.main_image,
      SKU: data?.SKU,
      metal_name: data?.Metal_name || "",
      stone_name: data?.Stone_name || "",
      size_name: data?.Size_name || "",
      Metal: data?.Metal,
      Color: data?.Color,
      Size: data?.Size,
      Style: data?.Style,
      Stones: data?.Stones,
      GrossWt: data?.GrossWt,
      NetWt: data?.NetWt,
      Unit: data?.Unit,
    },
    pos: {
      cart_id: data?.product_id,
      order_type: "rework_order",
      po_order_id: data?.po_order_id,
      status: data?.status,
    },
  });

  const getBulkRowsToAdd = (currentRows, items) => {
    const currentRecordIds = new Set(
      currentRows.flatMap((row) => {
        const recordId =
          getInventoryRecordId(row) || getInventoryRecordId(row?.product_details);
        return recordId ? [recordId] : [];
      })
    );
    const currentStockIds = new Set(
      currentRows.map((row) => row?.stock_id).filter(Boolean)
    );
    const duplicateRecordIds = [];
    const newRows = [];

    items.forEach((item) => {
      const recordId = getInventoryRecordId(item);
      if (recordId && currentRecordIds.has(recordId)) {
        duplicateRecordIds.push(recordId);
        return;
      }
      if (item?.stock_id && currentStockIds.has(item.stock_id)) {
        return;
      }
      if (recordId) {
        currentRecordIds.add(recordId);
      }
      if (item?.stock_id) {
        currentStockIds.add(item.stock_id);
      }
      newRows.push(mapInventoryProductToReworkRow(item));
    });

    return { newRows, duplicateRecordIds };
  };

  const addInventoryProductToTable = (item) => {
    if (isInventoryRecordInList(PO_OrdersList, item)) {
      error(t("This piece is already in the list"));
      return false;
    }

    UnSetdataTable("tbl_pos_order_table");
    setPO_OrdersList((current) => {
      if (isInventoryRecordInList(current, item)) {
        return current;
      }
      return [...current, mapInventoryProductToReworkRow(item)];
    });
    setTimeout(() => {
      SetdataTable("tbl_pos_order_table", "6", newcolumndata);
    }, 100);
    return true;
  };

  const inventoryProductSearch = useCallback(async () => {
    const search = filtername.trim();
    if (!search) {
      setInventorySearchResults([]);
      setSearchNoResults(false);
      setSearchLoading(false);
      return;
    }
    if (!commanSelected_loc) {
      error(t("Please select location"));
      setInventorySearchResults([]);
      setSearchNoResults(false);
      setSearchLoading(false);
      return;
    }
    setSearchLoading(true);
    setSearchNoResults(false);
    try {
      const postdata = {
        location_id: commanSelected_loc,
        search,
      };
      const resp = await _Api(
        postdata,
        `api/v1/Inventory/po/getInventoryProductBySearch`
      );
      if (resp.code === 200) {
        const items = Array.isArray(resp.data) ? resp.data : [];
        setInventorySearchResults(items);
        setSearchNoResults(items.length === 0);
      } else {
        setInventorySearchResults([]);
        setSearchNoResults(false);
        if (resp.errors) {
          error(typeof resp.errors === "string" ? resp.errors : String(resp.errors));
        }
      }
    } catch (err) {
      console.log(err, "err");
      setInventorySearchResults([]);
      setSearchNoResults(false);
    } finally {
      setSearchLoading(false);
    }
  }, [filtername, commanSelected_loc, t]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      inventoryProductSearch();
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [filtername, commanSelected_loc, inventoryProductSearch]);

  const selectInventoryProduct = async (item) => {
    if (selectingProduct) return;
    if (!commanSelected_loc) {
      error(t("Please select location"));
      return;
    }
    if (!item?._id) return;

    if (isInventoryRecordInList(PO_OrdersList, item)) {
      error(t("This piece is already in the list"));
      return;
    }

    setSelectingProduct(true);
    try {
      const resp = await _Api(
        {
          _id: item._id,
          location_id: commanSelected_loc,
        },
        `api/v1/Inventory/po/getinvprodtforrework`
      );
      if (resp.code === 200 && resp.data) {
        addInventoryProductToTable(resp.data);
        setFiltername("");
        setInventorySearchResults([]);
        setSearchNoResults(false);
        setShowProductSearchBar(false);
      } else if (resp.code === 404) {
        error(t("This piece is no longer available"));
      } else if (resp.code === 400) {
        error(formatReworkApiError(resp));
      } else if (resp.code === 500) {
        error(resp.message || t("Something went wrong"));
      } else {
        error(formatReworkApiError(resp));
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setSelectingProduct(false);
    }
  };

  useEffect(() => {
    callcolumns();
  }, []);
  useEffect(() => {
    if (newcolumndata?.length) {
      posorders_idshave();
    }
  }, [newcolumndata, posorders_idshave]);

  const openProductModal = (result, index) => {
    setOneproduct({
      ...result?.product_details,
      location_id: result?.product_details?.location_id || commanSelected_loc,
    });
    setoneproductindex(index);
  };

  const editproduct_submit = () => {
    if (oneproductindex === undefined || oneproductindex === null || !getoneproduct) return;
    const mainarray = [...PO_OrdersList];
    const updatedProduct = getoneproduct;
    mainarray[oneproductindex] = {
      ...mainarray[oneproductindex],
      stock_id: updatedProduct?.stock_id || mainarray[oneproductindex].stock_id,
      price:
        getReworkCostPrice(updatedProduct) ||
        mainarray[oneproductindex].price,
      product_details: {
        ...mainarray[oneproductindex].product_details,
        ...updatedProduct,
        metal_name: updatedProduct?.Metal_name || updatedProduct?.metal_name || "",
        stone_name: updatedProduct?.Stone_name || updatedProduct?.stone_name || "",
        size_name: updatedProduct?.Size_name || updatedProduct?.size_name || "",
      },
    };
    setPO_OrdersList(mainarray);
  };

  const deleteProduct = () => {
    const selected = document.querySelectorAll(".PO_OrdersList");
    for (let i = 0; i < selected.length; i++) {
      if (selected[i].checked) {
        let product_id = selected[i].getAttribute('data-id');
        setPO_OrdersList((current) =>
          current.filter((item) => item?.id !== product_id)
        );
        setSelecteditem((current) =>
          current.filter((item) => item !== product_id)
        );
        selected[i].checked = false;
      }
    }
    UnSetdataTable('tbl_pos_order_table');
    setTimeout(() => {
      SetdataTable("tbl_pos_order_table", "4", newcolumndata);
    }, 100);
  }

  const countstockid = async (stiockidindex) => {
    if (!stiockidindex?.trim()) {
      error(t("Please Entre Stock id"));
      return;
    }
    if (!commanSelected_loc) {
      error(t("Please select location"));
      return;
    }

    const stockIds = [...new Set(stiockidindex.split(/\s+/).map((id) => id.trim()).filter(Boolean))];
    if (!stockIds.length) {
      error(t("Somthing Went Wrong"));
      return;
    }

    const existingStockIds = new Set(
      PO_OrdersList.map((row) => row?.stock_id).filter(Boolean)
    );
    const requestStockIds = stockIds.filter(
      (id) => !existingStockIds.has(id)
    );
    const skippedDuplicates = stockIds.filter(
      (id) => existingStockIds.has(id)
    );

    if (!requestStockIds.length) {
      error(t("All stock IDs are already in the list"));
      return;
    }

    const GetloadingID = loading();
    try {
      const resp = await _Api(
        {
          stock_ids: requestStockIds,
          location_id: commanSelected_loc,
        },
        `api/v1/Inventory/po/getinvprodtforreworkBulk`
      );

      if (resp.code === 200) {
        const items = Array.isArray(resp.data) ? resp.data : [];
        const notAvailable = Array.isArray(resp.not_available_stock_ids)
          ? resp.not_available_stock_ids
          : [];

        const { newRows, duplicateRecordIds } = getBulkRowsToAdd(PO_OrdersList, items);

        if (newRows.length) {
          UnSetdataTable("tbl_pos_order_table");
          setPO_OrdersList((current) => {
            const { newRows: rowsToAdd } = getBulkRowsToAdd(current, items);
            return [...current, ...rowsToAdd];
          });
          setTimeout(() => {
            SetdataTable("tbl_pos_order_table", "6", newcolumndata);
          }, 100);
          Updateloading(t, GetloadingID, t("Added successfully!!"));
          if (notAvailable.length) {
            error(`${t("Not available for rework")}: ${notAvailable.join(", ")}`);
          }
        } else if (duplicateRecordIds.length) {
          Updateloading(
            t,
            GetloadingID,
            `${t("Already in list")}: ${duplicateRecordIds.join(", ")}`,
            "error"
          );
        } else if (notAvailable.length) {
          Updateloading(
            t,
            GetloadingID,
            `${t("Not available for rework")}: ${notAvailable.join(", ")}`,
            "error"
          );
        } else {
          Updateloading(t, GetloadingID, t("No items were added"), "error");
        }

        if (skippedDuplicates.length) {
          error(`${t("Already in list")}: ${skippedDuplicates.join(", ")}`);
        }
        if (duplicateRecordIds.length && newRows.length) {
          error(`${t("Already in list")}: ${duplicateRecordIds.join(", ")}`);
        }
      } else if (resp.code === 400) {
        Updateloading(t, GetloadingID, formatReworkApiError(resp), "error");
      } else if (resp.code === 500) {
        Updateloading(t, GetloadingID, resp.message || t("Something went wrong"), "error");
      } else {
        Updateloading(t, GetloadingID, formatReworkApiError(resp), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };

  const selectedproduct = (event) => {
    if (event.target.checked) {
      const mainselected = [...selecteditem, event.target.value];
      setSelecteditem(mainselected);
    } else {
      const result = selecteditem.filter((element) => {
        return element !== event.target.value;
      });
      setSelecteditem(result);
    }
  }
  useEffect(() => {
    if (SelectAllStatus) {
      const selected = document.querySelectorAll(".PO_OrdersList");
      let arrya = [];
      for (let i = 0; i < selected.length; i++) {
        if (selected[i].checked) {
          let product_id = selected[i].getAttribute('value');
          arrya.push(product_id);
        }
      }
      setSelecteditem(arrya);
    } else {
      setSelecteditem([]);
    }
  }, [SelectAllStatus]);
  const downloadexclsheet = async (format = poExportFormat) => {
    const handleValidation = (e) => {
      let formIsValid = true
      if (!commanSelected_loc) {
        formIsValid = false
        error(t("Please select location"));
        return;
      }
      return formIsValid
    }
    if (handleValidation()) {
      let GetloadingID = loading();
      try {
        let postdata = {
          "ship_to": commanSelected_loc,
          format: format || "xlsx",
        }
        let res = await _Api(postdata, "api/v1/Inventory/po/getPOSOrderListExportByLocation")
        if (res?.code === 200) {
          Updateloading(t, GetloadingID, (res?.message));
        } else {
          Updateloading(t, GetloadingID, (res.errors), 'error');
        }
      }
      catch (err) {
        console.log(err, "err")
      }
    }
  }

  return (
    <React.Fragment>
      <div className="main-body" style={{paddingTop: "0px"}}>
      <div className="create-po-sticky-header">
        <div className="row" id="new-brandcumcategory">
          <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
            <div className="main-content-wrapper-body-top-bar-left">
              <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
                {t("Transaction")} <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5L13 10L8 15" stroke="#A0A0A0" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>{t("Create Purchase Order")}</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="container" id="style-create-po-page">
          <div className="row">
            <div className="col-lg-12">
              <div className="top-heading-area">
                <div className="top-heading-area-left">
                  <Link to="/app/inventory" className="page-back-btn">
                    <img
                      src={base_url + "images/icons/arrow-left.png"}
                      alt=""
                    />
                  </Link>
                  <img src={base_url + "images/icons/home-icon.png"} alt="" />
                  <VoucherList
                    setcommanSelected_vouc={setcommanSelected_vouc}
                    group={"Purchase_order"}
                  ></VoucherList>
                </div>

              </div>
              <div className="main-body-top-tab-bar create-purchase-top-bar">
                <div
                  className="main-body-top-tab-bar-left-col nav nav-pills"
                  role="tablist"
                >
                  <Link
                    to="/app/inventory/createpo"
                    className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                  >
                    <span className="main-body-top-tab-bar-left-col-a-text">
                      <img
                        className="tab-hover-img-1"
                        src={base_url + "images/icons/price-list-icon.png"}
                        alt=""
                      />
                      <img
                        className="tab-hover-img-2"
                        src={
                          base_url + "images/icons/price-list-icon-green.png"
                        }
                        alt=""
                      />
                      {t("POS Order")}
                    </span>
                  </Link>
                  {state ? !state.createlist ?
                    <>
                      <Link
                        to="/app/inventory/createpoReplenishOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src={base_url + "images/icons/replenish-icon.png"}
                            alt=""
                          />
                          <img
                            className="tab-hover-img-2"
                            src={base_url + "images/icons/replenish-icon-green.png"}
                            alt=""
                          />
                          {t("Replenish Order")}
                        </span>
                      </Link>
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link active tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    </>
                    : (
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link active tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    ) : (
                    <>
                      <Link
                        to="/app/inventory/createpoReplenishOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src={base_url + "images/icons/replenish-icon.png"}
                            alt=""
                          />
                          <img
                            className="tab-hover-img-2"
                            src={base_url + "images/icons/replenish-icon-green.png"}
                            alt=""
                          />
                          {t("Replenish Order")}
                        </span>
                      </Link>
                      <Link
                        to="/app/inventory/createPOReworkOrder"
                        className="main-body-top-tab-bar-left-col-a nav-link active tab-hover table-refresh"
                      >
                        <span className="main-body-top-tab-bar-left-col-a-text">
                          <img
                            className="tab-hover-img-1"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          <img
                            className="tab-hover-img-2"
                            src="https://staticassets2.gis247.net/assets/v2/images/icons/free-stock.png"
                            alt=""
                            width={24}
                            height={24}
                            style={{ width: 24, height: 24, objectFit: "contain" }}
                          />
                          {t("Rework Order")}
                        </span>
                      </Link>
                    </>
                  )}

                </div>
              </div>
              <div className="tab-content">
                <div className="tab-pane active">
                  <div className="main-body-top-inputs-bar">
                    <div className="main-body-top-inputs-bar-col-left">
                      <label className="po-num-label  po-num-yellow">{t("po-xxx")}</label>
                      <LocationList
                        setcommanSelected_loc={setcommanSelected_loc}
                        addclass={state?.hidelocationid ? 'row_inactive' : ""} locationid={state ? state?.hidelocationid : ''}
                        commanSelected_vouc={commanSelected_vouc}
                      />
                      <SupplierList
                        setcommanSelected_sup={setcommanSelected_sup}
                      />
                      <TransAndDeliverDate TransactionDate={TransactionDate} DeliveryDate={DeliveryDate} setTransactionDate={setTransactionDate} setDeliveryDate={setDeliveryDate} />
                    </div>
                    <div className="main-body-top-inputs-bar-col-right">
                      <button
                        className="main-body-top-inputs-bar-col-right-submit-btn com-btn"
                        data-bs-toggle="modal"
                        data-bs-target="#createPurchaseModal"
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                  <div className="main-body-top-status-bar">
                    <Select
                      className=" select-set select p-0 main-content-wrapper-body-top-status-bar-select-num"
                      options={selectOptions}
                      value={{ label: limit, value: limit }}
                      onChange={(e) => { setLimit(e.value); posorders_idshave(e.value) }}
                      isSearchable={false}
                    />
                    <div className="main-body-top-status-bar-multi-date-picker">
                      <div className="main-body-top-tab-bar-right-col-search" ref={productSearchBar}>
                        {ShowProductSearchBar ? (
                          <div className="wrap-expandable-input-field">
                            <div className="main-body-top-status-bar-filter">
                              <button className="main-body-top-status-bar-filter-search">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                                    stroke="#606060"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              </button>
                              <input
                                type="text"
                                value={filtername}
                                className="main-body-top-status-bar-filter-input"
                                placeholder={t("Enter start of Stock ID or SKU")}
                                onChange={(e) => {
                                  setFiltername(e.target.value);
                                  setHighlightedIndex(0);
                                  setSearchNoResults(false);
                                }}
                                onKeyDown={(e) => {
                                  if (!inventorySearchResults?.length) return;

                                  if (e.key === "ArrowDown") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => (prev + 1) % inventorySearchResults.length);
                                  } else if (e.key === "ArrowUp") {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) =>
                                      prev === 0 ? inventorySearchResults.length - 1 : prev - 1
                                    );
                                  } else if (e.key === "Enter") {
                                    if (selectingProduct) return;
                                    const selected = inventorySearchResults[highlightedIndex];
                                    if (selected) {
                                      selectInventoryProduct(selected);
                                    }
                                  }
                                }}
                              />
                              {filtername ? (
                                <svg
                                  onClick={() => {
                                    setFiltername("");
                                    setInventorySearchResults([]);
                                    setSearchNoResults(false);
                                  }}
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13 13L7 7M7 7L1 1M7 7L13 1M7 7L1 13"
                                    stroke="#767676"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                ""
                              )}
                            </div>
                              {filtername ? (
                                <div className="dropdown-menu custom-search-dropdown catalog-all-search-dropdown po-search-dropdown show">
                                  {searchLoading || selectingProduct ? (
                                    <div className="po-search-dropdown-status">
                                      {selectingProduct
                                        ? t("Loading product...")
                                        : t("Searching...")}
                                    </div>
                                  ) : searchNoResults ? (
                                    <div className="po-search-dropdown-status">
                                      {t("No products found")}
                                    </div>
                                  ) : (
                                    <ul
                                      id="item_list_cardul"
                                      className="po-search-dropdown-list"
                                      ref={listRef}
                                    >
                                      {inventorySearchResults.map((result, index) => (
                                        <li
                                          onClick={() =>
                                            !selectingProduct &&
                                            selectInventoryProduct(result)
                                          }
                                          key={result._id || index}
                                          className={`dropdown-item pos-search-result-item${
                                            highlightedIndex === index
                                              ? " focused"
                                              : ""
                                          }${
                                            selectingProduct ? " disabled" : ""
                                          }`}
                                        >
                                          <div className="pos-search-result-thumb">
                                            {result.main_image ? (
                                              <img
                                                src={result.main_image}
                                                alt=""
                                                onError={(e) => {
                                                  e.target.onerror = null;
                                                  e.target.src =
                                                    "https://gis247.s3.us-east-2.amazonaws.com/placeholder-blank.png";
                                                }}
                                              />
                                            ) : null}
                                          </div>
                                          <div className="pos-search-result-text" >
                                            <div className="pos-search-result-name">
                                              {result.name}
                                            </div>
                                            <div className="pos-search-result-meta" style={{marginTop:'10px'}}>
                                              {result.SKU}
                                            </div>
                                            <div className="pos-search-result-meta">
                                              {result.stock_id
                                                ? result.stock_id
                                                : ""}
                                              {result.price
                                                ? " · " +
                                                  toFormatPrice(result.price, {
                                                    addSymbol: true,
                                                  })
                                                : ""}
                                            </div>
                                          </div>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </div>
                              ) : null}
                          </div>
                        ) : (
                          <button
                            className="search-icon"
                            onClick={() => setShowProductSearchBar(true)}
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13.9269 14.04L17.4 17.4M16.28 8.43998C16.28 12.7699 12.7699 16.28 8.44001 16.28C4.11009 16.28 0.600006 12.7699 0.600006 8.43998C0.600006 4.11006 4.11009 0.599976 8.44001 0.599976C12.7699 0.599976 16.28 4.11006 16.28 8.43998Z"
                                stroke="#606060"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        )}
                      </div>
                      <button className="print-export-dropdown-selected-icon d-none">
                        <img
                          src={base_url + "images/icons/printer-icon.png"}
                          alt=""
                        />
                      </button>
                      <button
                        className="print-export-dropdown-selected-icon"
                        data-bs-toggle="modal"
                        data-bs-target="#Stockidmodal"
                      >
                        <img
                          className="deletebtn d-block"
                          src={base_url + "images/icons/clone.svg"}
                          alt=""
                        />
                      </button>
                      <div className="print-export-dropdown-selected-icon">
                        <button className={
                          selecteditem.length > 0
                            ? "deletebtn btn d-block"
                            : "deletebtn btn d-none"
                        } onClick={deleteProduct}>
                          <svg width="20" height="20" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.43143 4.40639L9.32429 0.834961H14.6814L15.5743 4.40639M22.7171 4.40639H3.07429L4.86 25.835H19.1457L20.9314 4.40639H1.28857H22.7171ZM12.0029 9.76353V20.4778V9.76353ZM16.4671 9.76353L15.5743 20.4778L16.4671 9.76353ZM7.53857 9.76353L8.43143 20.4778L7.53857 9.76353Z" stroke="#5CC7C1" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </button>
                      </div>
                      <div
                        className="main-body-top-status-bar-note-button"
                        data-bs-toggle="modal"
                        data-bs-target="#notesModal"
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.83333 7.08333H10M5.83333 10H12.5M5.83333 15V16.9463C5.83333 17.3903 5.83333 17.6123 5.92436 17.7263C6.00352 17.8255 6.12356 17.8832 6.25045 17.8831C6.39636 17.8829 6.56973 17.7442 6.91646 17.4668L8.90434 15.8765C9.31043 15.5517 9.51347 15.3892 9.73957 15.2737C9.94017 15.1712 10.1537 15.0963 10.3743 15.051C10.6231 15 10.8831 15 11.4031 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V6.5C17.5 5.09987 17.5 4.3998 17.2275 3.86502C16.9878 3.39462 16.6054 3.01217 16.135 2.77248C15.6002 2.5 14.9001 2.5 13.5 2.5H6.5C5.09987 2.5 4.3998 2.5 3.86502 2.77248C3.39462 3.01217 3.01217 3.39462 2.77248 3.86502C2.5 4.3998 2.5 5.09987 2.5 6.5V11.6667C2.5 12.4416 2.5 12.8291 2.58519 13.147C2.81635 14.0098 3.49022 14.6836 4.35295 14.9148C4.67087 15 5.05836 15 5.83333 15Z" stroke="#A4A4A4" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>

                        {t("note")}
                      </div>
                      <div className="main-body-top-status-bar-print-export-dropdown dropdown">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <svg width="4" height="10" viewBox="0 0 4 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 10C1.30964 10 0.75 9.44036 0.75 8.75C0.75 8.05964 1.30964 7.5 2 7.5C2.69036 7.5 3.25 8.05964 3.25 8.75C3.25 9.44036 2.69036 10 2 10ZM2 6.25C1.30964 6.25 0.75 5.69036 0.75 5C0.75 4.30964 1.30964 3.75 2 3.75C2.69036 3.75 3.25 4.30964 3.25 5C3.25 5.33152 3.1183 5.64946 2.88388 5.88388C2.64946 6.1183 2.33152 6.25 2 6.25ZM2 2.5C1.30964 2.5 0.75 1.94036 0.75 1.25C0.75 0.559644 1.30964 0 2 0C2.69036 0 3.25 0.559644 3.25 1.25C3.25 1.58152 3.1183 1.89946 2.88388 2.13388C2.64946 2.3683 2.33152 2.5 2 2.5Z" fill="#2A2A2A"></path></svg>
                        </button>
                        <ul
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#posOrderReworkExportFormatModal"
                          >
                            <div className="dropdown-item-img">
                              <img
                                src={
                                  base_url + "images/icons/export-x-icon.png"
                                }
                                alt=""
                              />
                            </div>
                            <span>{t("export")}</span>
                          </li>
                          <li
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            data-bs-target="#columnModal"
                          >
                            <div className="dropdown-item-img">
                              <img
                                src={base_url + "images/icons/column-icon.png"}
                                alt=""
                              />
                            </div>
                            <span>{t("column")}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div className="container" id="style-create-po-page-body">
          <div className="row">
            <div className="col-lg-12">
              <div className="tab-content">
                <div id="pos_order" className="tab-pane active">
                  <div className="common-sub-table-wrap add-row position-relative overflow-auto">
                    <div className="main-body-main-table-wrap">
                      <table
                        id="tbl_pos_order_table"
                        className="common-table product-base-table w-100"
                      >
                        <Tablehead
                          tablehead={createPOReworktablehead}
                          tblName={"tbl_po_createpo_rework"}
                          setfilterby={""}
                          setShowoption={setSelectAllStatus}
                        />
                        <tbody>
                          {PO_OrdersList?.map((result, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="com-check ">
                                    <input
                                      id={"po_create_" + index}
                                      type="checkbox"
                                      data-key={index}
                                      onChange={selectedproduct}
                                      data-id={result?.id}
                                      value={result?.pos?.cart_id}
                                      className="PO_OrdersList posordertableHead"
                                    />
                                    <label
                                      htmlFor={"po_create_" + index}
                                      className="com-check-label"
                                    />
                                  </div>
                                </td>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="table-pro-img">
                                    <img
                                      src={result?.product_details?.main_image}
                                      alt=""
                                    />
                                  </div>
                                </td>
                                <td
                                  className="po-no link-color cursor-pointer col-highlight"
                                  onClick={() => openProductModal(result, index)}
                                  data-bs-toggle="modal"
                                  data-bs-target="#ProductInfoModal"
                                >
                                  {result?.product_details?.SKU}
                                </td>
                                <td>{formatDate(result?.createdAt || new Date())}</td>
                                <td className="col-highlight">
                                  <div className="col-input">
                                    <input
                                      value={result?.stock_id || ""}
                                      className="changestockids stock-field"
                                      type="text"
                                      name="stockid"
                                      disabled
                                      readOnly
                                    />
                                  </div>
                                </td>
                                <td className="col-highlight">
                                  {result?.product_details?.metal_name}
                                </td>
                                <td className="col-highlight">
                                  {result?.product_details?.stone_name}
                                </td>
                                <td className="col-highlight">
                                  {result?.product_details?.size_name}
                                </td>
                                {state?.createlist ?
                                  <td className="col-highlight">
                                    {result?.Qty}
                                  </td> :
                                  <td className="col-highlight">
                                    <div className="col-input">
                                      <input
                                        type="text"
                                        onChange={(e) => handleQtyChange(index, e.target.value)}
                                        name="Qty"
                                        value={result.Qty ?? ""}
                                        max={getMaxQty(result)}
                                      />
                                    </div>
                                  </td>
                                }
                                <td className="col-highlight">
                                  <div className="col-input">
                                    <input
                                      className="col-width"
                                      type="text"
                                      name="price"
                                      onChange={(e) =>
                                        mapChange_handle(
                                          index,
                                          e.target.value,
                                          "price"
                                        )
                                      }
                                      defaultValue={toFormatPrice(result.price)}
                                    />
                                  </div>
                                </td>
                                <td className="col-highlight">
                                  {" "}
                                  {toFormatPrice(
                                    parseInt(result.Qty) *
                                    parseFloat(toUnformatPrice(result.price, { addSymbol: true }))
                                  )}
                                </td>
                                <td className="danger-text col-highlight">
                                  {result.location_name}
                                </td>
                                <td className="col-highlight">
                                  <div className="col-input">
                                    <input
                                      className="col-width"
                                      type="text"
                                      name="remarkforrework"
                                      placeholder={t("Remark")}
                                      value={result.remarkforrework ?? ""}
                                      onChange={(e) =>
                                        mapChange_handle(
                                          index,
                                          e.target.value,
                                          "remarkforrework"
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td className="main-green-text left-0">
                              {selecteditem.length > 0 ? (
                                <span> {selecteditem.length} {t("item selected")}</span>
                              ) : (
                                ""
                              )}
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                            <td>
                              {PO_OrdersList?.reduce(
                                (a, v) => (a = a + parseInt(v.Qty)),
                                0
                              )}
                            </td>
                            <td />
                            <td>
                              {toFormatPrice(
                                PO_OrdersList?.reduce(
                                  (a, v) =>
                                  (a =
                                    a +
                                    parseInt(v.Qty) *
                                    parseFloat(toUnformatPrice(v.price))),
                                  0
                                )
                                , { addSymbol: true })}
                            </td>
                            <td />
                            <td />
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialModal />
        <ProductModal
          data_product={getoneproduct}
          setOneproduct={setOneproduct}
          editproduct_submit={editproduct_submit}
        />
      </div>
      <TableColumnModal
        tablehead={createPOReworktablehead}
        tblName={"tbl_po_createpo_rework"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={posorders_idshave}
      ></TableColumnModal>
      <ConfirmationModel statement={t("Create Purchase Order")} handler_submit={po_create_submit}></ConfirmationModel>
      <div
        className="modal fade common-modal"
        id="posOrderReworkExportFormatModal"
        tabIndex={-1}
        aria-labelledby="posOrderReworkExportFormatModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img
                className="common-modal-exclamation-img"
                src={base_url + "images/icons/exclamation-mark-green.png"}
                alt=""
              />
              <p className="modal-content-text mb-2">{t("Export format")}</p>
              <div className="d-flex justify-content-center gap-3 flex-wrap mb-3">
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="posOrderReworkExportFormat"
                    value="xlsx"
                    checked={poExportFormat === "xlsx"}
                    onChange={() => setPoExportFormat("xlsx")}
                  />
                  {t("Excel (.xlsx)")}
                </label>
                <label className="d-flex align-items-center gap-1">
                  <input
                    type="radio"
                    name="posOrderReworkExportFormat"
                    value="csv"
                    checked={poExportFormat === "csv"}
                    onChange={() => setPoExportFormat("csv")}
                  />
                  {t("CSV")}
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn modal-content-yes"
                data-bs-dismiss="modal"
                onClick={() => downloadexclsheet(poExportFormat)}
              >
                {t("Export")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <NotesModalLabel setForm_note={setForm_note}></NotesModalLabel>
      <Stockidmodal countstockid={countstockid} />
      <Advancedfiltermodel></Advancedfiltermodel>
    </React.Fragment>
  );
};
export default CreatePOReworkOrder;
